<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
             <label > Subject </label>
             <CRow >
              <CCol >
               <b-input v-model="form.subject" placeholder='Subject' > </b-input>
             
              </CCol>
            </CRow>     
            <label class="mt-2"> Description </label>
             <CRow >
              <CCol >
              <b-input v-model="form.description" placeholder='Description' > </b-input>
           
              </CCol>
            </CRow>
            <label class="mt-2" > Location </label>
             <CRow >
              <CCol >
              <b-input v-model="form.location" placeholder='Location' > </b-input>
             
              </CCol>
            </CRow>
            <hr>
            <label > Start Time </label>
             <CRow    >
              <CCol >
               <datetime class="animated-placeholder" format="DD/MM/YYYY H:i" width="300px" v-model="form.start_time"></datetime>
               <!-- <CButton  type="submit" v-on:click="clearDate()"  variant="outline" color="info">Clear</CButton> -->
              </CCol> 
            
            </CRow>
            <label class="mt-3" > End Time </label>
             <CRow >
              <CCol > 
               <datetime class="animated-placeholder" format="DD/MM/YYYY H:i" width="300px" v-model="form.end_time"></datetime>
              </CCol> 
             
            </CRow>
            
          </CCol> 
          </CRow>
       
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update()"  variant="outline" color="info">Update</CButton>
     
        </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import datetime from 'vuejs-datetimepicker';

import icareyouth from '@/services/icareyouth';

import moment from 'moment';

export default {
components: { datetime },
name: 'icaremodal',
  data () {
    return {
      hideCal: true,
    show: false,
    title: 'Default Title',
    mode: '',
    form:{
      id:'',
      uuid:'',
      subject:'',
      description:'',
      location:'',
      start_time:'',
      end_time:'',
      moment:'',
    },
    options:[],
   
    }
  },
  computed: {
      
   },
  
  mounted(){
    
  },

  clearDate(){
      this.form.start_time = ''
      this.$emit('input', '')
      this.toggleCal ()
    },

      toggleCal () {
      this.hideCal = !this.hideCal
    },

  created () {
    var self = this; 
     EventBus.$on('OPEN_MODAL_ICARE_YOUTH_MEETING', (params) => {
       
        if(params.data){
        console.log(this.form.subject)
        console.log(this.form.start_time)
        console.log(this.form.end_time)
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        
        
      icareyouth.getIcareMeeting(params.data)
      .then(res => {
      
      self.form.id = res.data.id;
      self.form.subject = res.data.subject;
      self.form.description = res.data.description;
      self.form.location = res.data.location;
      self.form.start_time  = moment(res.data.start_time).format ('DD/MM/YYYY H:mm');
      self.form.end_time  = moment(res.data.end_time).format ('DD/MM/YYYY H:mm');
      
       }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.uuid = this.$route.query.Pud;
        self.form.subject = "";
        self.form.description = "";
        self.form.location ="";
        self.form.start_time = "";
        self.form.end_time = "";
      }
 
    });
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(){
      this.show= false;
      icareyouth.createIcareMeeting(this.form.uuid, this.form)
      .then(res => {
        
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
     
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
      console.log( this.form.start_time)
    },
    update(){
      this.show = false;
      
      icareyouth.updateIcareMeeting(this.$route.query.Pud,this.form.id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
   
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
   
  }
}
</script>

<style>

</style>